module.exports = __webpack_public_path__ + "static/assets/mark-clark-profile.bb0c077.png";